export default "__VITE_ASSET__BvvTiBQi__"